module.exports = "images/nature_beach.d3fd677319445bf238777ad26b2bd3ab.png";